var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBirdAndWildlifeSpotting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Wild-Bird-Hunt--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wild Bird Hunt Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.64 8.88a0.25 0.25 0 0 0 0.24 -0.17c0.84 -2.21 0.85 -3.16 1.32 -4.13a5 5 0 0 0 -0.68 -1.5C7.51 0 3 0 2.8 0a0.51 0.51 0 0 0 -0.5 0.42 7.2 7.2 0 0 0 2.14 5.93 5 5 0 0 1 1.12 2.52 0.26 0.26 0 0 0 0.29 0.2 14.14 14.14 0 0 1 2.79 -0.19Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.76 21.62a7.25 7.25 0 0 0 3.72 -2.91 3.51 3.51 0 0 0 0.31 -1 0.5 0.5 0 0 1 0.5 -0.5 0.5 0.5 0 0 1 0.5 0.5 4.3 4.3 0 0 1 -0.45 1.5C19.29 21.07 19.7 21 19.87 21c3.15 -0.45 3.62 -3.83 3.42 -5.56a0.5 0.5 0 0 0 -0.54 -0.44l-4.67 0.47a8.65 8.65 0 0 0 -3 -3 0.27 0.27 0 0 1 -0.11 -0.22 0.26 0.26 0 0 1 0.13 -0.21c5.51 -3.1 7.55 -10.56 7.64 -10.9a0.51 0.51 0 0 0 -0.1 -0.45 0.5 0.5 0 0 0 -0.4 -0.19c-0.4 0.05 -9.86 1.09 -10.93 5.38a26 26 0 0 1 -1.46 4.42 0.24 0.24 0 0 1 -0.25 0.15A11 11 0 0 0 3 11.58a3.4 3.4 0 0 0 -1.7 3.15c-1 0.81 -0.54 2.67 -0.49 2.89a0.49 0.49 0 0 0 0.28 0.33 0.47 0.47 0 0 0 0.43 0 17.37 17.37 0 0 1 8 -1.57 1.48 1.48 0 0 1 1.24 1.92l-0.61 2a3.51 3.51 0 0 0 -3.43 0.43 1 1 0 0 0 1.2 1.6 1.6 1.6 0 0 1 0.9 -0.3 1.5 1.5 0 0 1 1.47 1.2 0.93 0.93 0 0 0 0.12 0.29 1 1 0 0 0 1.84 -0.52 2.73 2.73 0 0 0 -0.49 -1.38ZM4.3 15a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBirdAndWildlifeSpotting);
export default ForwardRef;